<template>
  <v-flex xs12 pt-0 mt-1 style="cursor: pointer">
    <v-layout row wrap>
      <v-flex xs12 py-0>
        <v-container py-3 px-0>
          <v-layout row wrap>
            <v-flex xs12>
              <v-layout row wrap body-1>
                <v-layout row @click="toggleView">
                  <v-flex xs2 py-0 class="columns-group">
                    {{ accountType(record) }} <br>
                    {{ updatedAt(record) }}
                  </v-flex>
                  <v-flex xs4 py-0 class="columns-group">
                    {{ partnerName(record) }} - {{ partnerDocument(record) }} <br>
                    {{ partnerId(record) }}
                  </v-flex>
                  <v-flex xs4 py-0 class="columns-group">
                    {{ subjectName(record) }} - {{ subjectDocument(record) }} <br>
                    {{ subjectId(record) }}
                  </v-flex>
                  <v-flex xs2 py-0 class="columns-group">
                    {{ status(record) }}
                  </v-flex>
                </v-layout>

                <transition name="fade">
                  <v-flex xs12 v-if="current_view === 'detailed'" py-4>
                    <v-layout row wrap align-center>
                      <v-flex xs8 v-if="record.status == 'reproved'">
                        <b style="padding: 20px;"> Motivo da Reprovação: </b>
                        {{ record.reason }}
                      </v-flex>
                      <v-flex xs8 v-else></v-flex>
                      <v-flex xs4>
                        <v-layout row justify-end style="padding-right: 50px;">
                          <v-btn v-if="record.status != 'approved'" dark class="ma-1 btn-style--secondary"
                            @click.stop="financialAccountAuthorizationApproval(record, 'approved')">
                            Aprovar
                          </v-btn>
                          <v-btn v-if="record.status != 'reproved'" class="cancel-btn"
                            @click.stop="showReproveReasonModal(record, 'reproved')">
                            Reprovar
                          </v-btn>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-flex xs12 mt-3 v-if="current_view === 'detailed'">
                      <company-form admin subject operation="update" :record="record.subject" v-if="isCompany" @onUpdate="onUpdate" @onReprove="onReprove" />
                      <person-form admin subject operation="update" :record="record.subject" v-if="isPerson" @onUpdate="onUpdate" @onReprove="onReprove" />
                    </v-flex>
                  </v-flex>
                </transition>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-container>
      </v-flex>
    </v-layout>
    <v-divider></v-divider>
    <div v-if="show_reason_modal" class="modal-overlay">
      <div class="modal-content">
        <h3>Motivo da Reprovação</h3>
        <textarea v-model="reprove_reason" placeholder="Digite o motivo..." />
        <div class="modal-footer">
          <button @click="addReprovalReason(record)">Confirmar</button>
          <button class="cancel-btn" @click="closeModal()">Cancelar</button>
        </div>
      </div>
    </div>
  </v-flex>
</template>
<script>
import utils from "./shared/Utils"
import AdminCompanyForm from "./AdminCompanyForm"
import AdminPersonForm from "./AdminPersonForm"

export default {
  name: 'SubjectFinancialAccountAuthorizationItem',
  components: {
    'company-form': AdminCompanyForm,
    'person-form': AdminPersonForm
  },
  props: {
    record: {
      type: Object
    }
  },
  data() {
    return {
      show_reason_modal: false,
      reprove_reason: null,
      current_view: 'short',
    }
  },
  computed: {
    showMoreBtn() {
      if ((this.config.records.length > 0) && (this.config.records.length % 100 == 0)) {
        return true
      } else {
        return false
      }
    },
    isPerson() {
      return utils.isPerson(this.record.subject)
    },
    isCompany() {
      return utils.isCompany(this.record.subject)
    }
  },
  methods: {
    i18n(str) {
      return this.$root.l(str)
    },
    partnerName(record) {
      return record.partner.social_name
    },
    partnerDocument(record) {
      return record.partner.document_type + ' ' + record.partner.document_number
    },
    partnerId(record) {
      return record.partner.id
    },
    subjectName(record) {
      return record.subject.social_name
    },
    partnerDocument(record) {
      return record.partner.document_type + ' ' + record.partner.document_number
    },
    subjectDocument(record) {
      return record.subject.document_type + ' ' + record.subject.document_number
    },
    subjectId(record) {
      return record.subject.id
    },
    status(record) {
      if (record.status == 'approved') {
        return this.i18n('Aprovado')
      } else if (record.status == 'reproved') {
        return this.i18n('Reprovado')
      } else if (record.status == 'pending') {
        return this.i18n('Pendente')
      }
      return record.status
    },
    accountType(record) {
      if (record.is_subject_account_owner == true) {
        return "Conta Própria"
      } else {
        return "Conta FPAY"
      }
    },
    onUpdate() {
      this.$emit('onUpdate', this.record)
      this.current_view = 'short'
    },
    onReprove() {
      this.$emit('onReprove', this.record)
      this.current_view = 'short'
    },
    updatedAt(record) {
      const date = utils.dbDateTimeToHuman(record.updated_at).split(' ')[0]
      const time = utils.dbDateTimeToHuman(record.updated_at).split(' ')[1]

      return date + ' ' + time
    },
    showReproveReasonModal() {
      this.show_reason_modal = true
    },
    financialAccountAuthorizationApproval(subjectFinancialAccountAuthorization, status) {
      this.current_view = 'short'
      subjectFinancialAccountAuthorization.reason = null

      let successCallback = (response) => {
        this.$emit('loadRecords', null)
      }

      let errorCallback = (response) => {
        debugger
      }

      let token = this.$cookies.get('api_token')

      let params = {
        status: status
      }

      if (status == 'reproved') {
        params.reason = this.reprove_reason
      }

      const subjectFinancialAccountAuthorizationId = subjectFinancialAccountAuthorization.id

      const url =
        this.$root.urls.admin_subjects_financial_account_authorization_base +
        '/account_requests' +
        '/' + subjectFinancialAccountAuthorizationId

      this.$http.put(url, params, { headers: { Authorization: `Bearer ${token}` } }).then(successCallback, errorCallback)
    },
    addReprovalReason(subjectFinancialAccountAuthorization) {
      if (this.reprove_reason == null || this.reprove_reason == '') {
        return
      } else {
        this.financialAccountAuthorizationApproval(subjectFinancialAccountAuthorization, 'reproved')
        this.current_view = 'short'
        this.closeModal()
      }
    },
    closeModal() {
      this.reprove_reason = null
      this.show_reason_modal = false
    },
    async toggleView(e) {
      if (e.target.type !== 'file') {
        if (this.current_view === 'short') {
          const token = this.$cookies.get('api_token')
          var response = await this.$http.get(this.$root.urls.admin__search, { params: { s: this.record.subject.id, mode: 'id' }, headers: { Authorization: `Bearer ${token}` } })
          this.record.subject = response.body.data[0]
          e.preventDefault()
        }

        this.current_view = (this.current_view === 'short') ? 'detailed' : 'short'
      }
    },
    mounted() {

    }
  }
}
</script>
<style>
.columns-group {
  display: flex;
  align-items: center;
  padding: 20px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-content {
  background: #f9fafc;
  padding: 24px;
  border-radius: 12px;
  width: 600px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  color: #2c3e50;
}

.modal-content h3 {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 12px;
  color: #2c3e50;
}

.modal-content textarea {
  width: 100%;
  height: 160px;
  border: 1px solid #cbd5e0;
  border-radius: 8px;
  padding: 12px;
  font-size: 14px;
  resize: vertical;
  box-sizing: border-box;
  color: #2c3e50;
  background-color: white;
}

.modal-content textarea:focus {
  outline: none;
  border-color: #1fd5c9;
  box-shadow: 0 0 0 2px rgba(31, 213, 201, 0.3);
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 10px;
}

.modal-footer button {
  background-color: #1fd5c9;
  border: none;
  color: white;
  padding: 10px 16px;
  font-size: 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.modal-footer button:hover {
  background-color: #17bcb2;
}

.cancel-btn {
  height: 56px !important;
  margin: 4px !important;
  background-color: #e5e5e5;
  color: #2c3e50;
}

.cancel-btn:hover {
  background-color: #cacfd2;
}

.modal-footer .cancel-btn {
  height: 56px !important;
  background-color: #e5e5e5;
  color: #2c3e50;
}

.modal-footer .cancel-btn:hover {
  background-color: #cacfd2;
}

.reprove-reason {
  font-size: 14px;
  color: #2c3e50;
  display: flex;
  align-items: center;
  height: 100%;
}
</style>


// WEBPACK FOOTER //
// src/SubjectFinancialAccountAuthorizationItem.vue